module.exports = __webpack_public_path__ + "static/GTAmerica-LightItalic-1f3ab9f4b1dd69c9da0c815ed1215488.woff2";